import { defineStore } from "pinia";
import { ref } from "vue";

export const useIframeEmbed = defineStore("iframeEmbed", () => {
  const ifHideHeader = ref(false);
  const ifIframe = ref(false)

  function init() {
    const url = new URL(document.location.href);
    const hideHeader = url.searchParams.get("ifHideHeader");
    if (hideHeader && hideHeader === "true") ifHideHeader.value = true;
    const isIframe = url.searchParams.get("isIframe");
    if (isIframe && isIframe === "true") ifIframe.value = true;

  }

  return {
    ifHideHeader,
    ifIframe,
    init,
  };
});
